import React, { useMemo, useState } from "react";
import { swapRunCells } from "./happyschoolApi";

const DAYS = ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];

// (24/10/2026) GV ĐỔI TIẾT trong 1 lớp: GV bấm vào tiết CỦA MÌNH ở "TKB cho GV & Học sinh — Toàn trường" -> form này
// hiện TKB của đúng lớp đó, chọn 1 tiết khác (hoặc ô trống buổi văn hoá) để đổi chỗ. Tô màu sẵn tiết nào đổi được /
// bị trùng lịch (GV khai bận, GV đang dạy lớp khác). TKB đã công bố: gửi yêu cầu, chờ Admin + GVCN + GV tiết kia duyệt.
const HappySchoolCellSwapDialog = ({ schoolId, runId, target, grid, classes, subjects, teacherName, sessions, isBusyAt, sessionKind, published, onClose, onSaved }) => {
  const { classId, day, period } = target;
  const cls = classes.find((c) => c.id === classId) || {};
  const className = cls.name || classId;
  const subjectById = useMemo(() => Object.fromEntries(subjects.map((s) => [s.id, s.name])), [subjects]);
  const classById = useMemo(() => Object.fromEntries(classes.map((c) => [c.id, c.name])), [classes]);
  const tn = (id) => (id ? teacherName[id] || "" : "");
  const [picked, setPicked] = useState(null); // {day, period}
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const keyOf = (d, p) => `${classId}|${d}|${p}`;
  const src = grid[keyOf(day, period)] || [];
  const tA = src[1] || null;

  // tid -> "d|p" -> key ô đang dạy (toàn trường)
  const teachingAt = useMemo(() => {
    const m = {};
    Object.entries(grid).forEach(([k, v]) => {
      if (!Array.isArray(v) || !v[1]) return;
      const [, d, p] = k.split("|");
      (m[v[1]] = m[v[1]] || {})[`${d}|${p}`] = k;
    });
    return m;
  }, [grid]);

  const slotLabel = (d, p) => {
    for (const s of sessions) { const x = s.periods.find((q) => q.global === p); if (x) return `${DAYS[d]} ${String(s.label || "").toLowerCase()} tiết ${x.idx + 1}`; }
    return `${DAYS[d]} tiết ${p + 1}`;
  };
  const otherClassAt = (tid, d, p, ignoreKey) => {
    const k = (teachingAt[tid] || {})[`${d}|${p}`];
    return k && k !== ignoreKey ? classById[k.split("|")[0]] || "lớp khác" : null;
  };

  // Trạng thái từng ô của lớp: {ok, disabled, reasons[]}
  const statusOf = (d, p, si) => {
    if (d === day && p === period) return { self: true };
    const raw = grid[keyOf(d, p)];
    if (raw && raw[0] === "HN") return { disabled: true, reasons: ["Tiết học nghề"] };
    const isLesson = !!(raw && raw[0] != null && subjectById[raw[0]]);
    if (raw && raw[0] != null && !isLesson) return { disabled: true, reasons: ["Ô đặc biệt"] };
    if (!isLesson) {
      const kind = sessionKind(className, d, si);
      if (kind && kind !== "vanhoa" && kind !== "nghe") return { disabled: true, reasons: [kind === "thiks" ? "Thi khảo sát" : "Lớp nghỉ buổi này"] };
    }
    const tB = isLesson ? raw[1] || null : null;
    const reasons = [];
    if (tA && tA !== tB) {
      if (isBusyAt(tA, d, p)) reasons.push(`${tn(tA)} khai bận giờ này`);
      const oc = otherClassAt(tA, d, p, keyOf(d, p));
      if (oc) reasons.push(`${tn(tA)} đang dạy ${oc} giờ này`);
    }
    if (tB && tB !== tA) {
      if (isBusyAt(tB, day, period)) reasons.push(`${tn(tB)} khai bận ${slotLabel(day, period)}`);
      const oc = otherClassAt(tB, day, period, keyOf(day, period));
      if (oc) reasons.push(`${tn(tB)} đang dạy ${oc} ${slotLabel(day, period)}`);
    }
    return { ok: reasons.length === 0, conflict: reasons.length > 0, reasons, empty: !isLesson, tB };
  };

  const cellText = (raw) => (raw && raw[0] != null && subjectById[raw[0]] ? `${subjectById[raw[0]]}${raw[1] ? ` — ${tn(raw[1])}` : ""}` : "(trống)");
  const pickedRaw = picked ? grid[keyOf(picked.day, picked.period)] : null;
  const pickedLesson = pickedRaw && pickedRaw[0] != null && subjectById[pickedRaw[0]] ? pickedRaw : null;

  const save = async () => {
    setErr("");
    if (!picked) { setErr("Chọn 1 tiết (ô màu xanh) trong bảng để đổi."); return; }
    setSaving(true);
    try {
      const r = await swapRunCells(schoolId, runId, { classId, fromDay: day, fromPeriod: period, toDay: picked.day, toPeriod: picked.period, reason });
      window.alert(r && r.pending ? (r.message || "Đã gửi yêu cầu đổi tiết — chờ duyệt.") : "Đã đổi tiết.");
      onSaved && onSaved(r);
    } catch (e) {
      setErr(e.message || "Đổi tiết thất bại.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={box} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
          <h3 style={{ margin: 0 }}>⇄ Đổi tiết lớp {className}</h3>
          <button type="button" onClick={onClose} style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer" }}>✕</button>
        </div>
        <p style={{ margin: "6px 0 10px", color: "#374151", fontSize: 13 }}>
          Tiết cần đổi: <b>{slotLabel(day, period)}</b> — <b>{cellText(src)}</b>.<br />
          Chọn 1 tiết khác của lớp {className} để đổi chỗ.{" "}
          <span style={{ color: "#047857" }}>■ Xanh: đổi được</span> · <span style={{ color: "#b91c1c" }}>■ Đỏ: trùng lịch (rê chuột / chạm để xem lý do)</span> · <span style={{ color: "#9ca3af" }}>■ Xám: không đổi được</span>
        </p>

        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
            <thead>
              <tr>
                <th style={th}>Tiết</th>
                {DAYS.map((d) => <th key={d} style={{ ...th, minWidth: 92 }}>{d}</th>)}
              </tr>
            </thead>
            <tbody>
              {sessions.map((ses, si) => ses.periods.map((p, ti) => (
                <tr key={`${si}-${ti}`} style={ti === 0 && si > 0 ? { borderTop: "2px solid #9ca3af" } : undefined}>
                  <td style={{ ...td, whiteSpace: "nowrap", background: "#f9fafb" }}>{ti === 0 ? <b>{ses.label} </b> : null}T{ti + 1}</td>
                  {DAYS.map((_, d) => {
                    const st = statusOf(d, p.global, si);
                    const raw = grid[keyOf(d, p.global)];
                    const on = picked && picked.day === d && picked.period === p.global;
                    const clickable = st.ok;
                    const bg = st.self ? "#fde68a" : on ? "#0ea5a3" : st.disabled ? "#f3f4f6" : st.conflict ? "#fee2e2" : "#dcfce7";
                    const color = on ? "#fff" : st.disabled ? "#9ca3af" : st.conflict ? "#991b1b" : "#111827";
                    const title = st.self ? "Tiết đang đổi" : (st.reasons || []).join("\n") || (st.empty ? "Ô trống — chuyển tiết sang đây" : "Đổi được");
                    return (
                      <td key={d} title={title}
                        onClick={() => { if (clickable) setPicked({ day: d, period: p.global }); else if (st.conflict) setErr(`Không đổi được với ${slotLabel(d, p.global)}: ${st.reasons.join("; ")}.`); }}
                        style={{ ...td, background: bg, color, cursor: clickable ? "pointer" : "not-allowed", outline: on ? "2px solid #0f766e" : st.self ? "2px solid #d97706" : undefined }}>
                        {raw && raw[0] === "HN" ? "HN" : raw && raw[0] != null && subjectById[raw[0]] ? (
                          <>
                            <div style={{ fontWeight: 600 }}>{subjectById[raw[0]]}</div>
                            {raw[1] && <div style={{ fontSize: 10, opacity: 0.85 }}>{tn(raw[1])}</div>}
                          </>
                        ) : st.ok ? <span style={{ fontSize: 10 }}>(trống)</span> : ""}
                      </td>
                    );
                  })}
                </tr>
              )))}
            </tbody>
          </table>
        </div>

        {picked && (
          <div style={{ marginTop: 10, padding: "8px 10px", borderRadius: 8, background: "#f0fdfa", border: "1px solid #99f6e4", fontSize: 13 }}>
            <b>Sau khi đổi:</b>
            <div>• {slotLabel(day, period)}: {pickedLesson ? cellText(pickedLesson) : "(trống)"}</div>
            <div>• {slotLabel(picked.day, picked.period)}: {cellText(src)}</div>
          </div>
        )}

        <label style={{ display: "block", fontSize: 14, margin: "10px 0 0" }}>Lý do đổi tiết
          <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="VD: đi công tác, họp, dạy bù..." style={{ width: "100%", boxSizing: "border-box", marginTop: 4, padding: 6, border: "1px solid #d1d5db", borderRadius: 6 }} />
        </label>
        {published && (
          <p style={{ margin: "8px 0 0", fontSize: 12, color: "#92400e" }}>
            TKB đã công bố: yêu cầu cần <b>Admin</b>, <b>GVCN lớp</b> và <b>GV của tiết được đổi</b> duyệt mới áp dụng (xem ở mục "Duyệt sửa TKB").
          </p>
        )}
        {err && <p style={{ color: "#dc2626", margin: "8px 0 0" }}>{err}</p>}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
          <button type="button" onClick={onClose} disabled={saving} style={btnGhost}>Hủy</button>
          <button type="button" onClick={save} disabled={saving || !picked} style={{ ...btnPrimary, opacity: picked ? 1 : 0.5 }}>
            {saving ? "Đang gửi..." : published ? "Gửi yêu cầu đổi tiết" : "Đổi tiết"}
          </button>
        </div>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
const box = { background: "#fff", borderRadius: 12, padding: 18, width: 760, maxWidth: "96vw", maxHeight: "94vh", overflowY: "auto", boxShadow: "0 20px 40px rgba(0,0,0,.2)" };
const th = { border: "1px solid #e5e7eb", padding: "4px 6px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "center" };
const td = { border: "1px solid #e5e7eb", padding: "3px 4px", textAlign: "center", verticalAlign: "middle", height: 34 };
const btnGhost = { padding: "8px 14px", border: "1px solid #d1d5db", background: "#fff", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const btnPrimary = { padding: "8px 16px", border: "none", background: "#0ea5a3", color: "#fff", borderRadius: 6, cursor: "pointer", fontWeight: 700 };

export default HappySchoolCellSwapDialog;
